<template>
  <div style="padding: 30px 0">
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>职位负责IE</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="12" style="padding-left:20px">
        <p>姓名：{{ source.ie_user.name }}</p>
      </a-col>
      <a-col>
        <p>邮箱：{{ source.ie_user.email }}</p>
      </a-col>
      <a-col span="12" style="padding-left:20px">
        <p>电话：{{ source.ie_user.tel }}</p>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>职位负责BD</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="12" style="padding-left:20px">
        <p>姓名：{{ source.bd_ie_user.name }}</p>
      </a-col>
      <a-col>
        <p>邮箱：{{ source.bd_ie_user.email }}</p>
      </a-col>
      <a-col span="12" style="padding-left:20px">
        <p>电话：{{ source.bd_ie_user.tel }}</p>
      </a-col>
    </a-row>
    <a-divider></a-divider>

    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>任职资格</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col style="padding-left:20px">
        <p v-html="source.description.replace(/\n/g, '<br>')"></p>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>案情通告</b>
          </a-col>
        </a-row>
      </a-col>
      <!-- <a-col>
        <a-button type="primary" icon="plus">案情通告</a-button>
      </a-col>-->
    </a-row>
    <a-row type="flex" justify="start">
      <template v-for="item in list">
        <a-col :key="item.id" span="24" style="padding-left:20px">
          <div style="color:#9e9e9e">{{ item.created_at }}</div>
          <p v-html="item.content.replace(/\n/g, '<br>')">{{ item.content }}</p>
        </a-col>
      </template>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>岗位职能</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="24" style="padding-left:20px">
        <p v-html="source.requirements.replace(/\n/g, '<br>')"></p>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>职位卖点</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="24" style="padding-left:20px">
        {{
        source.selling_point_tags.join("，") || "暂无"
        }}
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>招聘原因</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="24" style="padding-left:20px">
        {{
        source.recruitment_reason_tags.join("，") || "暂无"
        }}
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>搜寻方向</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="24" style="padding-left:20px">
        <template
          v-if="
            source.first_seek_companys && source.first_seek_companys.length > 0
          "
        >
          <p>
            <b>第一目标公司</b>
          </p>
          <p :key="item.id" v-for="item in source.first_seek_companys">
            {{ item.company_name }}：
            {{
            item.seek_products &&
            item.seek_products.map(item => item.name).join("，")
            }}
          </p>
        </template>
        <template
          v-if="
            source.second_seek_companys &&
              source.second_seek_companys.length > 0
          "
        >
          <p>
            <b>第二目标公司</b>
          </p>
          <p :key="item.id" v-for="item in source.second_seek_companys">
            {{ item.company_name }}：
            {{
            item.seek_products &&
            item.seek_products.map(item => item.name).join("，")
            }}
          </p>
        </template>
      </a-col>
    </a-row>
    <!-- <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>面试流程</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="24" style="padding-left:20px">
        <p>面试轮次：{{source.interview_times_name}}</p>
        <template v-for="(item, index) in source.job_interviews">
          <div :key="item.id">{{`第${index+1}轮面试：`}}{{item.content}}</div>
        </template>
      </a-col>
    </a-row>-->
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>候选人要求</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="12" style="padding-left:20px">
        <p>性别要求：{{ source.gender_id | sexy }}</p>
      </a-col>
      <a-col>
        <p>
          学校类型：{{
          source.school_type == 0
          ? "不限"
          : source.school_type == 1
          ? "985/211"
          : "海归"
          }}
        </p>
      </a-col>
      <a-col span="12" style="padding-left:20px">
        <p>工作经验：{{ source.experience_name }}</p>
      </a-col>
      <a-col span="12" style="padding-left:20px">
        <p>学历要求：{{ source.education_name }}</p>
      </a-col>
      <a-col span="12" style="padding-left:20px">
        <p>年龄要求：{{ source.age_requirement }}</p>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>职位进展</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col style="padding-left:20px">
        <p>{{ source.recruitment_progress || "暂无" }}</p>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>其他说明</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="start">
      <a-col span="12" style="padding-left:20px">
        <p>职位级别：{{ source.level }}</p>
      </a-col>
      <a-col>
        <p>薪资制度：{{ source.salary_type_name }}</p>
      </a-col>
      <a-col span="12" style="padding-left:20px">
        <p>试用期薪资比例：{{ source.probationary_salary_ratio }}%</p>
      </a-col>
      <a-col span="12" style="padding-left:20px">
        <p>下属团队：{{ source.subordinate_team }}</p>
      </a-col>
      <a-col span="12" style="padding-left:20px">
        <p>平级情况：{{ source.samelevel }}</p>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import Api from "@/api";
export default {
  name: "Job",
  props: ["source"],
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let { list } = await Api.order.caseNotice({ job_id: this.source.id });
      this.list = list;
    }
  }
};
</script>
